export default {
  All: 'all',
  Yes: 'yes',
  No: 'no',
}
